import { useGetList } from "ra-core";

import type { Contact } from "../types";
import { DashboardStepper } from "./DashboardStepper";
import { StudioDashboard } from "./StudioDashboard";

export const Dashboard = () => {
  const { total, isPending } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });

  if (isPending) {
    return null;
  }

  if (!total) {
    return <DashboardStepper step={1} />;
  }

  return <StudioDashboard />;
};
